import React from "react";
import { SessionEventsProvider } from "@/contexts/session-events";
import { SessionEventsPage } from "./page";

export const SessionEventsPageWrapper: React.FC = () => {
  return (
    <SessionEventsProvider>
      <SessionEventsPage />
    </SessionEventsProvider>
  );
};
